import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as utils from '@/utils/utils';
import _ from 'lodash';
import Velocity from 'velocity-animate';

/**
 * 保证同时只有一个键盘存在
 */
let globalKeyboard: BaseKeyboard | undefined;
/**
 * 自定义键盘基类
 */
@Component({
})
export default class BaseKeyboard extends Vue {
  @Prop()
  public title;
  @Prop()
  /** 当点击键盘外部时，需要关闭键盘；但是点击关联元素不应该关闭，可以使用这个参数排除 */
  public exclude: Node | Node[] | ((current: Node) => boolean);
  @Prop({ default: '' })
  public theme: string;

  public fnBodyClick: undefined | ((event: Event) => void) = undefined;
  private touchStartClientY: number = 0;
  private activeScrollEl: HTMLElement | null = null;
  private onKeyboardTouchStart: ((e: TouchEvent) => void) | null = null;
  private onKeyboardTouchMove: ((e: TouchEvent) => void) | null = null;

  public mounted() {
    if (globalKeyboard) {
      globalKeyboard.handleClose();
    }
    globalKeyboard = this;

    this.fnBodyClick = (e) => {

      if (!utils.isParentOfEventElement(this.$refs.basekeyboard as any, e)) {
        let isExclude = false;
        const target = e.target as Node;
        if (_.isArray(this.exclude)) {
          isExclude = this.exclude.includes(target);
        } else if (_.isFunction(this.exclude)) {
          isExclude = this.exclude(target);
        } else if (this.exclude === target) {
          isExclude = true;
        }
        if (!isExclude) {
          this.handleClose();
        }
      }
    };
    document.body.addEventListener('touchstart', this.fnBodyClick, true);

    const baseEl = this.$refs.basekeyboard as HTMLElement | undefined;
    if (baseEl) {
      this.onKeyboardTouchStart = (e: TouchEvent) => {
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        this.touchStartClientY = touch.clientY;
        this.activeScrollEl = this.findScrollableAncestor(e.target as Node, baseEl);
      };

      this.onKeyboardTouchMove = (e: TouchEvent) => {
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        const deltaY = touch.clientY - this.touchStartClientY;
        const scrollEl = this.activeScrollEl;

        if (!scrollEl) {
          if (e.cancelable !== false) e.preventDefault();
          return;
        }

        const scrollTop = scrollEl.scrollTop;
        const scrollHeight = scrollEl.scrollHeight;
        const clientHeight = scrollEl.clientHeight;
        const maxScrollTop = Math.max(0, scrollHeight - clientHeight);

        if ((scrollTop <= 0 && deltaY > 0) || (scrollTop >= maxScrollTop && deltaY < 0)) {
          if (e.cancelable !== false) e.preventDefault();
        }
      };

      baseEl.addEventListener('touchstart', this.onKeyboardTouchStart, { passive: true });
      baseEl.addEventListener('touchmove', this.onKeyboardTouchMove, { passive: false });
    }
  }
  public destroyed() {
    if (this.fnBodyClick) {
      document.body.removeEventListener('touchstart', this.fnBodyClick, true);
    }
    const baseEl = this.$refs.basekeyboard as HTMLElement | undefined;
    if (baseEl && this.onKeyboardTouchStart) {
      baseEl.removeEventListener('touchstart', this.onKeyboardTouchStart as any);
      this.onKeyboardTouchStart = null;
    }
    if (baseEl && this.onKeyboardTouchMove) {
      baseEl.removeEventListener('touchmove', this.onKeyboardTouchMove as any);
      this.onKeyboardTouchMove = null;
    }
  }
  public handleClose() {
    this.$emit('close');
  }

  private findScrollableAncestor(node: Node | null, root: HTMLElement): HTMLElement | null {
    let el: HTMLElement | null = (node as any) instanceof HTMLElement ? (node as any) : null;
    while (el && el !== root) {
      const style = window.getComputedStyle(el);
      const overflowY = style.overflowY;
      const canScroll = (overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight;
      if (canScroll) return el;
      el = el.parentElement;
    }

    const rootStyle = window.getComputedStyle(root);
    const rootOverflowY = rootStyle.overflowY;
    const rootCanScroll = (rootOverflowY === 'auto' || rootOverflowY === 'scroll') && root.scrollHeight > root.clientHeight;
    return rootCanScroll ? root : null;
  }

  public enter(el, done) {
    el.style['max-height'] = '0px';
    Velocity(el,
      {
        'max-height': '100%',
      },
      {
        duration: 200,
        complete: done,
      });
  }
  public leave(el, done) {
    el.style['max-height'] = '100%';
    Velocity(el,
      {
        'max-height': '0px',
      },
      {
        duration: 100,
        complete() {
          done();
        },
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/BaseKeyboard/BaseKeyboard.ts